import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Dialog,RenderIf } from '../../../../components';
import LiabilityAnalysisForm from './LiabilityAnalysisForm';
import AllCaseInfoForm from './AllCaseInfoForm';
import AddMedicalProviderBillForm from './AddMedicalProviderBillForm';
import PainAndSufferingAnalysisForm from './PainAndSufferingAnalysisForm';
import EconomicDamageAnalysisForm from './EconomicDamageAnalysisForm';
import Progressbar from './Progressbar';
import Constants from '../../../../Constants';
import '../../../../assets/css/redesign.css'
import { useSelector } from 'react-redux';
import useAxios from '../../../../hooks/useAxios';
import { storeCaseInfoData,storeCaseAdditionalInfoData } from '../../../../redux/actions/caseInfo';
import { useDispatch } from 'react-redux';
import { changeAddCaseFormStep, preProcessedMedicalRecordsData, storeLiablityEstern, cancelCaseSubmission, generateSummaryLoading, saveCaseProgress } from '../../../../redux/actions/liabilty';
import { storeMedicalProvider } from '../../../../redux/actions/medicalProviders';
import { storePainAndSufferingData } from '../../../../redux/actions/painAndSuffering';
import { storeEconomicDamage } from '../../../../redux/actions/economicDamage';
import Tabs from '../../../../components/ui-control/tabs';
import { clearStoredGlobalState, createMedicalObject, generateRandomIds, getDefendantId, putFileToS3, separateFilenameAndExtension, setDefendantId, transformFormDataToCaseData, withRetry } from "../../../../utils/helper";
import XLoader from "../../../../components/common/XLoader";
import { DefaultMultiPlaintiffName, liabilityFilesKey } from "../../../../utils/constant";
import { getDefaultClient, defaultDamage, getDefaultDefendant, defaultMedicalProviders, defaultPainAndSuffering } from '../../../../utils/formSchema';
import ConfirmationBox from '../Confirmation';
import { toaster } from '../../../../utils/toast';
import AppConfig from '../../../../AppConfig';
import LinearProgressWithLabel from '../../../../components/common/LinearProgressWithLabel';
import { GenerateUUID } from '../../../../Utils';
import { offSocketEvent, onSocketEvent } from "../../../../services/SocketService";

const defaultClient = getDefaultClient();

const defaultDefendant = getDefaultDefendant();

const AddCaseForm = () => {
  const { caseId } = useParams();
  const innerRefs = useRef(null);
  const [formDataPayload, setFormDataPayload] = useState({});
  const { getData, isLoading } = useAxios()
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isCaseDataSaved = useSelector(state => state.isCaseSaved.isCaseSaved);
  const formSteps = useSelector(state => state.formikRefCapture.addCaseFormStep);
  const isSaveCaseProgress = useSelector(state => state.SaveCaseProgress.saveCaseProgress);
  const cancelSubmission = useSelector(state => state.CancelCaseSubmission.cancelCaseSubmission)
  const caseInfoFromStore = useSelector(state => state.caseInformation.caseData);
  const liabilityFromStore = useSelector(state => state.liability.liability);
  const medicalProvidersFromStore = useSelector(state => state.medicalProviderData.medicalProvider);
  const painAndSufferingFromStore = useSelector(state => state.painAndSuffering.painAndSufferingData);
  const economicDamageFromStore = useSelector(state => state.economicDamage.damage);
  
  const [showShadow, setShowShadow] = useState(false);
  const [shouldRenderConfirmationBox, setShouldRenderConfrimationBox] = useState(false)
  const [plainTiffs, setPlainTiffs] = useState([defaultClient]);
  const [defendants, setDefendants] = useState([defaultDefendant]);
  const [selectedTiffIndex,setSelectedTiffIndex] = useState(0);
  const [selectedDefendant,setSelectedDefendant] = useState(0);
  const [addCaseIsLoading, setAddCaseIsLoading] = useState(false);
  const [caseFileUploadProgress, setCaseFileUploadProgress] = useState(0);
  const { postData } = useAxios()
  
  const { postData: pfqPostData } = useAxios({
    baseURL: AppConfig.PfqBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
  })

 useEffect(() => {
    const handlePreProcess = (data) => {
      if (data?.caseId === caseId) {
        // dispatch(storeInjuryAnalysis(data?.injury));
        dispatch(preProcessedMedicalRecordsData({
          isPreProcessRecordLoading: data.isPreProcessRecordLoading,
          medicalProcessedData: data?.clientRecords,
        }));
      }
    };

    const handleSummaryLoading = (data) => {
      if (data?.caseId === caseId) {
        dispatch(generateSummaryLoading(data.medicalSummaryLoading));
      }
    };

    onSocketEvent('preProcessRecordResult', handlePreProcess);
    onSocketEvent('generateSummaryLoading', handleSummaryLoading);

    return () => {
      offSocketEvent('preProcessRecordResult', handlePreProcess);
      offSocketEvent('generateSummaryLoading', handleSummaryLoading);
    };
  }, [dispatch, caseId]);

  useEffect(() => {
    
    if (medicalProvidersFromStore.medicalFiles.length === 0) {
      dispatch(storeMedicalProvider({ medicalFiles: [defaultMedicalProviders] }));
    }
    if (painAndSufferingFromStore.painAndSufferingArr.length === 0) {
      dispatch(storePainAndSufferingData({ painAndSufferingArr: [defaultPainAndSuffering] }));
    }
    if (economicDamageFromStore.ecoDamage == null) {
      dispatch(storeEconomicDamage({ ecoDamage: [defaultDamage] }));
    }
  }, []);


  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setShowShadow(true);
      } else {
        setShowShadow(false);
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    dispatch(storeCaseAdditionalInfoData({isDisableSubmitButton: true}));
    const fetchCaseDetails = async () => {
      if (caseId) {
        try {
          const response = await getData(`${Constants.ApiUrl.case.getCaseById}/${caseId}`);
          if(!response.success){
            toaster({ message:response.message, success:response.success });
            navigate("/cases");
          }
          const caseDetails = response.data;
          const { caseInfo, clients, defendants, liability, teamIds } = caseDetails;
          caseInfo.caseId = caseId;
          clients.forEach((client, index) => {
            if (!client.clientId) {
              client.clientId = generateRandomIds();
            }
          });
          defendants.forEach((defendant, index) => {
            if (!getDefendantId(defendant)) {
              setDefendantId(defendant, null);
            }
          });
          dispatch(storeCaseInfoData({ caseInfo, clients, defendants, teamIds }));
          dispatch(storeLiablityEstern(liability));
          const medicalProviders = [];
          const painAndSuffering = [];
          const damage = [];
          clients.forEach((client)=>{
            medicalProviders.push(client.medicalProviders); 
            painAndSuffering.push({...client.painAndSuffering,age:client.personalInfo.age,gender:client.personalInfo.gender}); 
            damage.push(client.damage); 
          });
          dispatch(storeMedicalProvider({medicalFiles:medicalProviders}));
          dispatch(storePainAndSufferingData({painAndSufferingArr:painAndSuffering}));
          dispatch(storeEconomicDamage({ecoDamage:damage}));

          const clientRecords= clients.map((client)=> {
                return {
                    clientId: client?.clientId,
                    medicalRecords: client?.medicalProviders?.postAccident?.result?.medicalRecords?.flat(),
                    preMedicalRecords: client?.medicalProviders?.preAccident?.result?.medicalRecords?.flat(),
                    medicalBillRecords: client?.medicalProviders?.postAccident?.result?.medicalBillRecords,
                }
            })
          dispatch(preProcessedMedicalRecordsData({
            isPreProcessRecordLoading: caseDetails?.isPreProcessRecordLoading,
            medicalProcessedData: clientRecords,
          }));

          // Set the full objects for display and logic
          setPlainTiffs(clients);
          setDefendants(defendants);
        } catch (error) {
          console.error('Error fetching case details:', error);
        }
      }
      dispatch(storeCaseAdditionalInfoData({isDisableSubmitButton: false}));
    };

    fetchCaseDetails();
    
  }, [caseId]);

  useEffect(() => {
    if (isCaseDataSaved) { // will remove this code (pk)
      economicDamageFromStore.processCase = false;
      const formData = { liabilityFromStore, caseInfoFromStore, economicDamageFromStore, painAndSufferingFromStore, medicalProvidersFromStore, isSaveCaseProgress }
      processPromptInputContentOnServer(formData)
    }
  }, [isCaseDataSaved])

  const backToCases = () => {
      if (formSteps === 4) {
         const PrevButton = innerRefs.current.querySelector('#previous');
         if (PrevButton) {
            PrevButton.click()
         }
      } else {
         const submitButton = innerRefs.current.querySelector('#submit');
         if (submitButton) {
            submitButton.click()
         }
      }

      if (!isCaseDataSaved) {
         setShouldRenderConfrimationBox(true)
      } else {
         setShouldRenderConfrimationBox(false)
         navigate('/cases')
         localStorage.removeItem('formState');
         clearStoredGlobalState(dispatch);
      }

   }



  const incrementFormStep = () => {

    dispatch(changeAddCaseFormStep(formSteps + 1))
  }

  const Decrement = () => {
    dispatch(changeAddCaseFormStep(formSteps - 1))
  }


  const addCases = async (formPayload) => {
      formPayload = {
         ...formPayload,
         caseInfo: structuredClone(formPayload?.caseInfo) || caseInfoFromStore,
         liability: structuredClone(formPayload?.liability) || liabilityFromStore,
         medicalProviders: structuredClone(formPayload?.medicalProviders?.medicalFiles) || medicalProvidersFromStore?.medicalFiles,
         painAndSuffering: structuredClone(formPayload?.painAndSuffering?.painAndSufferingArr) || painAndSufferingFromStore?.painAndSufferingArr,
         damage: structuredClone(formPayload?.damage) || economicDamageFromStore
      }
      if (!cancelSubmission) {// back to list without saving (Will remove this cancelSubmission state code)
         navigate("/cases");
         return
      }

      const caseId = formPayload?.caseId
      let medicalProviders = formPayload?.medicalProviders;

      if (!formPayload.damage.processCase || formPayload.isSaveCaseProgress) {
         formPayload.damage.processCase = false;
      }

      const medicalObj = createMedicalObject(medicalProviders);

      const postMedicalRecords = medicalObj.postAccident.map(elem => {
         return elem?.flatMap(providerLevel => {
            const providerName = providerLevel?.providerName;
            return providerLevel?.source?.map(file => {
               const blob = new Blob([file], { type: file.type });
               const newFile = new File([blob], file.name, { type: file.type });
               return {
                  ...(!file?.s3UrlPath && { file: newFile }),
                  ...(file?.s3UrlPath && { ...file }),
                  metaData: {
                     providername: providerName,
                     originalfilename: file.name,
                     typeofrecord: 'postMedicalRecords',
                     ...(file?.s3UrlPath && { caseId }),
                  }
               };
            }) || [];
         });
      })

      const preMedicalRecords = medicalObj.preAccident.map((elem) => {
         return elem?.flatMap(providerLevel => {
            const providerName = providerLevel?.providerName;

            return providerLevel?.source?.map(file => {
               const blob = new Blob([file], { type: file.type });
               const newFile = new File([blob], file.name, { type: file.type });

               return {
                  ...(!file?.s3UrlPath && { file: newFile }),
                  ...(file?.s3UrlPath && { ...file }),
                  metaData: {
                     providername: providerName,
                     originalfilename: file.name,
                     typeofrecord: 'preMedicalRecords',
                     ...(file?.s3UrlPath && { caseId }),
                  }
               };
            }) || [];
         });
      });


      const processFiles = (fileArray, typeOfRecord) => {
         return fileArray?.map((data) => {
            if (liabilityFilesKey.includes(typeOfRecord)) {
               let { file = null } = data;
               if (file) {
                  return {
                     ...data,
                     metaData: {
                        originalfilename: file.name,
                        typeofrecord: typeOfRecord,
                     }
                  };
               } else {
                  return data
               }
            } else {
               return {
                  file: data,
                  metaData: {
                     originalfilename: data.name,
                     typeofrecord: typeOfRecord,
                  }
               };
            }
         })
      };

      const processXMultiImageUploadFiles = (fileArray, typeOfRecord) => {
         return fileArray?.map((v) => {
            // const blob = new Blob([v?.file], { type: v?.file?.type });
            return {
               // ...(!v?.s3UrlPath && { file: new File([blob], v?.file?.name, { type: v?.file.type }), }),
               // ...(v?.s3UrlPath && { ...v }),
               ...v,
               metaData: {
                  originalfilename: v.name,
                  typeofrecord: typeOfRecord,
                  isSelected: String(v?.isSelected),
                  // ...(v?.s3UrlPath && { caseId }),
               }
            };
         });
      };

      let lossOfEarning = [];
      let futureMedicalExpense = [];
      let bodilyInjuriesImageFiles = [];
      const damageArr = formPayload.damage?.ecoDamage || [];
      damageArr.forEach((elem, index) => {
         if (elem?.lossOfEarning) { lossOfEarning[index] = processFiles(elem.lossOfEarning, "lossOfEarning") }
         if (elem?.futureMedicalExpense) { futureMedicalExpense[index] = processFiles(elem.futureMedicalExpense, "futureMedicalExpense") }
      });

      const painAndSufferingArr = formPayload.painAndSuffering || [];
      painAndSufferingArr.forEach((elem, index) => {
         if (elem?.bodilyInjuriesImageFiles) { bodilyInjuriesImageFiles[index] = processXMultiImageUploadFiles(elem.bodilyInjuriesImageFiles, "bodilyInjuriesImageFiles") }
      });


      let policeReportData = processFiles([...formPayload.liability?.policeReportData || []], 'policeReportData');
      let incidentReports = processFiles([...formPayload.liability?.incidentReports || []], 'incidentReports');
      let expertSafetyReport = processFiles([...formPayload.liability?.expertSafetyReport || []], 'expertSafetyReport');
      let witnessStatements = processFiles([...formPayload.liability?.witnessStatements || []], 'witnessStatements');
      let accidentSceneFiles = processFiles([...formPayload?.liability?.accidentSceneFiles || []], 'accidentSceneFiles');
      let productImageFiles = processFiles([...formPayload?.liability?.productImageFiles || []], 'productImageFiles');


      const organizeFilesForUpload = (fileCollections) => {
         const uploadData = {
            preSignedRequests: [],
            fileObjects: []
         };

         Object.entries(fileCollections).forEach(([fileType, files]) => {
            if (!Array.isArray(files) || files.length === 0) return;

            const isLiabilityFile = liabilityFilesKey.includes(fileType);

            files.forEach((fileItem, index) => {
               if (!fileItem || fileItem.length === 0) return;

               if (isLiabilityFile) {
                  organizeLiabilityFile(fileItem, fileType, index, uploadData);
               } else {
                  organizeNonLiabilityFile(fileItem, fileType, index, uploadData);
               }
            });
         });

         return uploadData;
      };

      const organizeLiabilityFile = (fileItem, fileType, originalIndex, uploadData) => {
         // Skip files already in S3
         if (fileItem?.s3UrlPath) return;

         // All liability files go to index 0
         const targetIndex = 0;
         ensureStructureExists(targetIndex, fileType, uploadData);

         const fileMetadata = createFileMetadata(fileItem.file, fileItem.metaData, originalIndex);

         uploadData.fileObjects[targetIndex][fileType].push(fileItem.file);
         uploadData.preSignedRequests[targetIndex][fileType].push(fileMetadata);
      };

      const organizeNonLiabilityFile = (fileItem, fileType, itemIndex, uploadData) => {
         ensureStructureExists(itemIndex, fileType, uploadData);
         uploadData.preSignedRequests[itemIndex][fileType] = fileItem.map((file, fileIndex) => {
            if (file?.s3UrlPath) {
               return handleExistingS3File(file, itemIndex, fileType, uploadData);
            }
            return handleNewFile(file, itemIndex, fileType, fileIndex, uploadData);
         });
      };

      const handleExistingS3File = (file, index, fileType, uploadData) => {
         const s3FileRef = {
            s3UrlPath: file.s3UrlPath,
            metaData: file.metaData
         };

         uploadData.fileObjects[index][fileType].push(s3FileRef);
         return s3FileRef;
      };

      const handleNewFile = (file, index, fileType, fileIndex, uploadData) => {
         const fileMetadata = createFileMetadata(file.file, file.metaData, fileIndex);
         uploadData.fileObjects[index][fileType].push(file.file);
         return fileMetadata;
      };

      const ensureStructureExists = (index, fileType, uploadData) => {
         uploadData.preSignedRequests[index] ??= {};
         uploadData.fileObjects[index] ??= {};
         uploadData.preSignedRequests[index][fileType] ??= [];
         uploadData.fileObjects[index][fileType] ??= [];
      };

      const createFileMetadata = (file, metaData, fileIndex) => {
         const originalFilename = metaData?.originalfilename || "unknown.txt";
         const uuid = GenerateUUID();
         const { ext } = separateFilenameAndExtension(originalFilename);

         return {
            fileName: `${uuid}.${ext}`,
            fileType: file?.type,
            metaData,
            fileIndex
         };
      };

      const fileCollections = {
         policeReportData,
         accidentSceneFiles,
         bodilyInjuriesImageFiles,
         postAccident: postMedicalRecords,
         preAccident: preMedicalRecords,
         incidentReports,
         expertSafetyReport,
         witnessStatements,
         productImageFiles,
         futureMedicalExpense,
         lossOfEarning
      };

      const { preSignedRequests: preSignedObj, fileObjects: filesObj } = organizeFilesForUpload(fileCollections);

      setAddCaseIsLoading(true);
      const totalCaseFileSize = filesObj.reduce((finalTotal, plainTiff) => {
         const fileSize = Object.values(plainTiff).flat().filter(file => file && typeof file?.size === 'number').reduce((total, file) => total + file?.size, 0);
         return finalTotal + fileSize;
      }, 0);
      let uploadedBytes = new Map();
      const updateCaseFileUploadProgress = (file, loaded, total) => {
         uploadedBytes.set(file.name, loaded);
         let totalUploaded = Array.from(uploadedBytes.values()).reduce((sum, bytes) => sum + bytes, 0);
         if (totalCaseFileSize === 0) {
            setCaseFileUploadProgress(100);
         } else {
            setCaseFileUploadProgress((totalUploaded / totalCaseFileSize) * 100);
         }
      };


      if (Object.keys(preSignedObj).length >= 1) {
         const generatePresignedUrlsRes = await postData('/generate-presigned-urls', { preSignedObjs: preSignedObj });
         formPayload.s3UniqueId = generatePresignedUrlsRes?.s3UniqueId || '';

         if (generatePresignedUrlsRes?.status === 200 && Array.isArray(generatePresignedUrlsRes.results)) {
            for (let plainTiffIndex = 0; plainTiffIndex < generatePresignedUrlsRes.results.length; plainTiffIndex++) {
               const elem = generatePresignedUrlsRes.results[plainTiffIndex];

               if (!elem) continue;
               for (const preSignedKey of Object.keys(elem)) {
                  //  combineFiles use for grouping by provider Name 
                  const combineFiles = {
                     postAccident: {},
                     preAccident: {}
                  };
                  const preSignedUrls = elem[preSignedKey];
                  const uploadedS3Objects = await Promise.all(
                     (preSignedUrls || []).map(async (preSignedUrl, index) => {
                        try {
                           const file = filesObj?.[plainTiffIndex]?.[preSignedKey]?.[index];
                           if (!file) return null;
                           if (file?.s3UrlPath) return { urlKey: file?.s3UrlPath, metaData: file?.metaData };
                           return await withRetry(async () => await putFileToS3(preSignedUrl, file, updateCaseFileUploadProgress));
                        } catch (error) {
                           return null;
                        }
                     })
                  );
                  for (const s3Object of uploadedS3Objects.filter(Boolean)) {
                     const s3UrlPath = s3Object.urlKey;
                     const { providername, typeofrecord, originalfilename, isSelected } = s3Object.metaData || {};

                     if (preSignedKey === 'postAccident' || preSignedKey === 'preAccident') {
                        // Grouping by providerName 
                        const key = `${preSignedKey}_${providername}`;
                        combineFiles[preSignedKey][key] = combineFiles[preSignedKey][key] || [];
                        combineFiles[preSignedKey][key].push({ s3UrlPath, name: originalfilename });
                     } else if (liabilityFilesKey.includes(preSignedKey)) {
                        const file = formPayload.liability[preSignedKey][s3Object.fileIndex];
                        let obj = {
                           s3UrlPath: s3Object.urlKey,
                           name: originalfilename,
                           defendants: file.defendants
                        }
                        formPayload.liability[preSignedKey][s3Object.fileIndex] = obj
                     } else if (preSignedKey === "bodilyInjuriesImageFiles") {
                        let obj = {
                           s3UrlPath: s3Object.urlKey,
                           name: originalfilename,
                           isSelected: isSelected === "true" || isSelected === true
                        }
                        formPayload.painAndSuffering[plainTiffIndex][preSignedKey][s3Object.fileIndex] = obj;
                      }
                      else {
                        combineFiles[preSignedKey] = combineFiles[preSignedKey] || [];
                        combineFiles[preSignedKey][plainTiffIndex] = combineFiles[preSignedKey][plainTiffIndex] || [];
                        combineFiles[preSignedKey][plainTiffIndex].push({ s3UrlPath, name: originalfilename });
                     }
                  }

                  if (preSignedKey === 'postAccident' || preSignedKey === 'preAccident') {
                     formPayload.medicalProviders[plainTiffIndex][preSignedKey].medicalRecords = (medicalObj[preSignedKey][plainTiffIndex] || []).map(v => {
                        const medicalRecordsKey = `${preSignedKey}_${v.providerName}`;
                        return {
                           providerName: v.providerName,
                           source: combineFiles?.[preSignedKey]?.[medicalRecordsKey] || []
                        };
                     });
                  }
                  else if (combineFiles[preSignedKey] && (preSignedKey === "lossOfEarning" || preSignedKey === "futureMedicalExpense")) {
                     formPayload.damage.ecoDamage[plainTiffIndex][preSignedKey] = combineFiles[preSignedKey][plainTiffIndex];
                  }
               }
            }
         }

      }

      const caseData = transformFormDataToCaseData(formPayload);
      console.log("requesting with case data:\n", caseData);
      if (caseData?.isDraftCase) {
         dispatch(generateSummaryLoading(0));
         await pfqPostData(Constants.ApiUrl.preProcessMedicalRecords, JSON.stringify(caseData)).then(async (response) => {
            if (!response?.success) { toaster({ message: response.message, success: false }); }
            setAddCaseIsLoading(false);
            setCaseFileUploadProgress(0);
            if (!caseId) {
               navigate(response.caseId, { replace: true });
            }
         }).catch((err) => console.log(err))

      } else {
         if (!caseData.isSaveCaseProgress) { clearStoredGlobalState(dispatch); };
         await pfqPostData(Constants.ApiUrl.create, JSON.stringify(caseData)).then(async (response) => {
           setAddCaseIsLoading(false);
           setCaseFileUploadProgress(0);
            if (!response?.success) {
               toaster({ message: response.message, success: false });
            }
            if (caseData.isSaveCaseProgress) {
               dispatch(saveCaseProgress(false));
               toaster({ message: "Case data saved successfully", success: response?.success });
            } else {
               navigate("/cases");
            }
         }).catch((err) => console.log(err));
      }
  }


  const finalFormStepNumber = 4

  const processPromptInputContentOnServer = (data) => {
    data.caseId = caseId
    addCases(data);
  }

  const fromStepValue = (value) => {
    if (formSteps === finalFormStepNumber) {
      handlePrevClick()
    }else{
      handleNextClick()
    }
    dispatch(changeAddCaseFormStep(value))
    setTimeout(() => {
      dispatch(changeAddCaseFormStep(value))
    }, 0);
  }

  const onHandleSubmitClick = (formData) => {
    //;
    formData = { ...formDataPayload, ...formData }
    formData.isSaveCaseProgress = isSaveCaseProgress;

    setFormDataPayload(formData);

    if (formData.isDraftCase) {
      formData.caseId = caseId;
      addCases(formData);
    }
    else {
      if (isSaveCaseProgress) {
        processPromptInputContentOnServer(formData);
      } else if (formSteps === finalFormStepNumber) {
        dispatch(changeAddCaseFormStep(0))
        processPromptInputContentOnServer(formData);
      } else {
        incrementFormStep();
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const handleNextClick = () => {
    const submitButton = innerRefs.current.querySelector('#submit');
    if (submitButton) {
      dispatch(cancelCaseSubmission(true))
      submitButton.click()
    }
  }

  const handlePrevClick = () => {
    const prevButton = innerRefs.current.querySelector('#previous');
    if (prevButton) {
      prevButton.click()
    }
  }

  const updatePlainTiff = (clientObj) => {
    setPlainTiffs(prev => {
      const updated = [...prev];
      updated[selectedTiffIndex] = clientObj;
      return updated;
    });
  };

  const updateDefendant = (defendantObj) => {
    setDefendants(prev => {
      const updated = [...prev];
      updated[selectedDefendant] = defendantObj;
      return updated;
    });
  };

  const addMedicalProviderElement = () => {
    dispatch(storeMedicalProvider({ medicalFiles: [...medicalProvidersFromStore.medicalFiles, defaultMedicalProviders] }));
  }

  const addPainAndSufferingElement = () => {
    dispatch(
      storePainAndSufferingData({
        painAndSufferingArr: [
          ...painAndSufferingFromStore.painAndSufferingArr,
          defaultPainAndSuffering,
        ],
      })
    );
  };

  const addDamageElement = () => {
    dispatch(
      storeEconomicDamage({
        ecoDamage: [...economicDamageFromStore.ecoDamage, defaultDamage],
      })
    );
  };

  const addNewPlainTiff = (clientObj) => {
    const prevLength = plainTiffs.length;
    setPlainTiffs(prev => {
      if (
        prevLength === 1 &&
        prev[0]?.personalInfo?.clientName === DefaultMultiPlaintiffName.DEFAULT_PLAINTIFF_Name
      ) {
          clientObj.clientId = prev[0]?.clientId;
          return [clientObj];
      }
      else{
        console.log("adding plaintiff");
        addMedicalProviderElement();
        addPainAndSufferingElement();
        addDamageElement();
        return [...prev, clientObj];
      }
    });
    setSelectedTiffIndex(0);
  };

  const addNewDefendant = (defendantObj) => {
    setDefendants(prev => {
      if (
        prev.length === 1 &&
        prev[0]?.personalInfo?.name === DefaultMultiPlaintiffName.DEFAULT_DEFENDANT_Name
      ) {
          defendantObj.defendantId = prev[0]?.defendantId;
          return [defendantObj];
      }
      return [...prev, defendantObj];
    });
    setSelectedDefendant(0);
  }

  const deletePlainTiff = (deletedIndex) => {
    if (plainTiffs.length === 1) {
      setPlainTiffs([defaultClient]);
      dispatch(storeMedicalProvider({ medicalFiles: [defaultMedicalProviders] }));
      dispatch(storePainAndSufferingData({ painAndSufferingArr: [defaultPainAndSuffering] }));
      dispatch(storeEconomicDamage({ ecoDamage: [defaultDamage] }));
      setSelectedTiffIndex(0);
      return;
    }

    if (medicalProvidersFromStore?.medicalFiles && medicalProvidersFromStore?.medicalFiles[deletedIndex]) {
      const updated = {
        ...medicalProvidersFromStore,
        medicalFiles: medicalProvidersFromStore.medicalFiles.filter((_, index) => index !== deletedIndex),
      };
      dispatch(storeMedicalProvider(updated));
    }
    if (painAndSufferingFromStore?.painAndSufferingArr && painAndSufferingFromStore?.painAndSufferingArr[deletedIndex]) {
      const updated = {
        ...painAndSufferingFromStore,
        painAndSufferingArr: painAndSufferingFromStore.painAndSufferingArr.filter((_, index) => index !== deletedIndex),
      };
      dispatch(storePainAndSufferingData(updated));
    }
    if (economicDamageFromStore?.ecoDamage && economicDamageFromStore?.ecoDamage[deletedIndex]) {
      const updated = {
        ...economicDamageFromStore,
        ecoDamage: economicDamageFromStore.ecoDamage.filter((_, index) => index !== deletedIndex),
      };
      dispatch(storeEconomicDamage(updated));
    }
    setPlainTiffs(prev => prev.filter((elem, index) => index !== deletedIndex));
    if (deletedIndex <= selectedTiffIndex) {
      setSelectedTiffIndex(0);
    }
  }

  const deleteDefendant = (deletedIndex) => {
    if (defendants.length === 1) {
      setDefendants([defaultDefendant]);
      setSelectedDefendant(0);
      return;
    }

    const defedant = defendants[deletedIndex];
    if (liabilityFromStore) {
      const fileKeyList = ["policeReportData", "incidentReports", "witnessStatements", "expertSafetyReport", "accidentSceneFiles"];
      for (let key in liabilityFromStore) {
        if (fileKeyList.includes(key)) {
          liabilityFromStore[key] = [...(liabilityFromStore[key] || [])].map(elem => {
            if (elem.defendants.includes(defedant.id)) {
              return {
                ...elem,
                defendants: elem.defendants.filter(defId => defId !== defedant.id),
              };
            }
            return elem;
          });
        } else {
          liabilityFromStore[key] = [...(liabilityFromStore[key] || [])].filter(elem =>
            !elem.defendants.includes(defedant.id)
          );
        }
      }
      dispatch(storeLiablityEstern(liabilityFromStore));
    }
    setDefendants(prev => prev.filter((elem, index) => index !== deletedIndex));
    if (deletedIndex <= selectedDefendant) {
      setSelectedDefendant(0);
    }
  }


  return (
  <>
    <section className='content-wrapper'>
      <div className={`container layout-container case-form`}>
        <div className={`listing`}>
            <div className='container p-0'>
              <RenderIf shouldRender={isLoading}>
                <div className='tableLoader'>
                  <XLoader />
                </div>
              </RenderIf>
              <RenderIf shouldRender={!isLoading}>
                <div className="case-section">
                  <h1 className="section-title  mb-0 mt-3 ms-16">Create Case</h1>
                  <div className="sticky-header-wrapper">
                    <Progressbar formSteps={formSteps} onNextClick={handleNextClick} innerRefs={innerRefs} fromStepValue={fromStepValue} />
                    <RenderIf shouldRender={plainTiffs.length > 1 && (formSteps === 2 || formSteps === 3 || formSteps === 4)}>
                      <Tabs
                        tabList={plainTiffs.map(t => ({ ...t, name: t.personalInfo?.clientName }))}
                        selectedTabIndex={selectedTiffIndex}
                        onTabChange={(index) => setSelectedTiffIndex(index)}
                        formSteps={formSteps}
                      />
                    </RenderIf>
                    <RenderIf shouldRender={defendants.length > 1 && formSteps === 1}>
                      <Tabs
                        tabList={defendants.map(d => ({ ...d, name: d.personalInfo?.name }))}
                        selectedTabIndex={selectedDefendant}
                        onTabChange={(index) => setSelectedDefendant(index)}
                        formSteps={formSteps}
                      />
                    </RenderIf>
                    <div className={`section-with-centered-shadow ${!showShadow ? 'shadow-hidden' : ''}`}>
                    </div>
                  </div>
                  <RenderIf shouldRender={formSteps === 0}>
                    <AllCaseInfoForm
                      onSubmit={onHandleSubmitClick}
                      backToCases={backToCases}
                      innerRef={innerRefs}
                      selectedTiffIndex={selectedTiffIndex}
                      addNewPlainTiff={addNewPlainTiff}
                      updatePlainTiff={updatePlainTiff}
                      deletePlainTiff={deletePlainTiff}
                      plainTiffs={plainTiffs}
                      setSelectedTiffIndex={setSelectedTiffIndex}
                      addNewDefendant={addNewDefendant}
                      defendants={defendants}
                      updateDefendant={updateDefendant}
                      selectedDefendant={selectedDefendant}
                      setSelectedDefendant={setSelectedDefendant}
                      deleteDefendant={deleteDefendant}
                      formSteps={formSteps}
                    />
                  </RenderIf>
                  <RenderIf shouldRender={formSteps === 1}>
                    <LiabilityAnalysisForm
                      onSubmit={onHandleSubmitClick}
                      stepDecrement={Decrement}
                      backToCases={backToCases}
                      innerRef={innerRefs}
                      defendants={defendants}
                      selectedDefendant={selectedDefendant}
                      formSteps={formSteps}
                    />
                  </RenderIf>
                  <RenderIf shouldRender={formSteps === 2}>
                    <AddMedicalProviderBillForm
                      onSubmit={onHandleSubmitClick}
                      stepDecrement={Decrement}
                      backToCases={backToCases}
                      innerRef={innerRefs}
                      plainTiffs={plainTiffs}
                      selectedTiffIndex={selectedTiffIndex}
                      setSelectedTiffIndex={setSelectedTiffIndex}
                      formSteps={formSteps}
                    />
                  </RenderIf>
                  <RenderIf shouldRender={formSteps === 3}>
                    <PainAndSufferingAnalysisForm
                      onSubmit={onHandleSubmitClick}
                      stepDecrement={Decrement}
                      backToCases={backToCases}
                      innerRef={innerRefs}
                      plainTiffs={plainTiffs}
                      selectedTiffIndex={selectedTiffIndex}
                      formSteps={formSteps}
                      setPlainTiffs={setPlainTiffs}
                    />
                  </RenderIf>
                  <RenderIf shouldRender={formSteps === 4}>
                    <EconomicDamageAnalysisForm
                      onSubmit={onHandleSubmitClick}
                      stepDecrement={Decrement}
                      backToCases={backToCases}
                      innerRef={innerRefs}
                      plainTiffs={plainTiffs}
                      selectedTiffIndex={selectedTiffIndex}
                      formSteps={formSteps}
                      setPlainTiffs={setPlainTiffs}
                    />
                  </RenderIf>
                </div>
              </RenderIf>
            </div>
        </div>
      </div>
    </section>
    <RenderIf shouldRender={addCaseIsLoading}>
      <Dialog onToggleDialog={(isDialogOpen) => { }} isModalOpen={addCaseIsLoading} mode="small-half" isCloseIconHidden={false}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <h3 className="title">Please wait while files are uploading...</h3>
        </div>
        <LinearProgressWithLabel style={{ marginTop: '2rem' }} value={caseFileUploadProgress} />
      </Dialog>
    </RenderIf>
    <RenderIf shouldRender={shouldRenderConfirmationBox}>
      <ConfirmationBox isDialogOpen={shouldRenderConfirmationBox} setShouldRenderConfrimationBox={setShouldRenderConfrimationBox} />
    </RenderIf>
  </>
  )
}

export default AddCaseForm;